import { deepMerge } from 'js/utils/Utils'
import { TextureLoader } from 'three'
import BaseImagesLoader from 'js/modules/_base/helper/resourceLoader/image/BaseImagesLoader'

const defaults = {}

export default class WebglImagesLoader extends BaseImagesLoader {
  constructor(options = {}) {
    super()
    deepMerge(this, defaults, options)
  }

  async load(imageInfo, onComplete) {
    await new Promise((resolve) => {
      if (imageInfo.drawType === 'gl') {
        new TextureLoader().load(
          imageInfo.src,
          (texture) => {
            texture.name = String(imageInfo.src)
            Object.defineProperty(texture, 'externalResourcesType', { value: 'texture' })
            imageInfo.texture = texture
            resolve(texture)

            onComplete(imageInfo)
          },
          (xhr) => {},
          (xhr) => {
            // throw 'An error happened';
            resolve()
            onComplete(imageInfo)
          }
        )
      } else {
        if (imageInfo.src && imageInfo.src.length) {
          const image = new Image()
          image.onload = () => {
            resolve()
            onComplete(imageInfo)
          }
          image.onerror = () => {
            resolve()
            onComplete(imageInfo)
          }

          image.src = imageInfo.src
          imageInfo.image = image
        } else {
          resolve()
          onComplete(imageInfo)
        }
      }
    })
  }
}